import React from "react";
import { reportError } from "./crash";

/* The last line of defence (main.tsx wraps the whole app in it): a render
   crash outside a routed page — the sidebar, the sign-in screen, a public hub
   page — used to leave a blank white screen. This reports it (lib/crash.ts)
   and shows a card with one thing to do. Pages have their own boundary
   (PageErrorBoundary in app.tsx) that keeps the rest of the app running. */
export class CrashBoundary extends React.Component<{ children?: React.ReactNode }, { err: any }> {
  constructor(props: any) { super(props); this.state = { err: null }; }
  static getDerivedStateFromError(err: any) { return { err }; }
  componentDidCatch(err: any, info: any) {
    try { console.error("[app-crash]", err, info); } catch (e) {}
    reportError(err, { kind: "boundary", componentStack: info && info.componentStack });
  }
  render() {
    if (!this.state.err) return this.props.children as any;
    return (
      <div style={{ minHeight: "100dvh", display: "grid", placeItems: "center", padding: 16, background: "var(--bg, #f6f8f7)" }}>
        <div className="card pad" role="alert" style={{ maxWidth: 440, width: "100%", textAlign: "center", padding: "36px 24px" }}>
          <h1 className="display" style={{ fontSize: 22, margin: "0 0 8px" }}>Something went wrong</h1>
          <p className="muted" style={{ fontSize: 14.5, margin: "0 0 18px" }}>
            The app hit an error it couldn't recover from. Reload to carry on — anything already saved is still there.
          </p>
          <button className="btn btn-primary" onClick={() => location.reload()}>Reload</button>
        </div>
      </div>
    );
  }
}
